import type { ConsentStatus } from "./generated";
import { apiFetch } from "./client";

/**
 * PRIV-1 third-party egress consent. The backend records per-user consent to
 * each external provider (Exa, TinyFish Search, TinyFish Agent, Gemini) and — when enforcement is
 * on — blocks those tools until a record exists.
 */

/** Current consent status for the signed-in user. */
export function fetchConsent(): Promise<ConsentStatus> {
  return apiFetch<ConsentStatus>("/api/v1/consent");
}

/** Record the user's consent to `provider`; returns the updated status. */
export function recordConsent(provider: string): Promise<ConsentStatus> {
  return apiFetch<ConsentStatus>("/api/v1/consent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ provider }),
  });
}
